import React from 'react';

var OverlayList = function (_a) {
    var position = _a.position, children = _a.children, labels = _a.labels;
    return (React.createElement("div", { className: "pgc-overlay-wr ".concat(position) },
        labels,
        children));
};

export { OverlayList };
